import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { CommandName } from '../CommandViewModel';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class EditRecordCommand extends CategoryCommand<TActionArgsValues> {
  public static COMMAND_NAME = 'edit' as const;
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.EDIT,
    };
  }

  public getIcon(): IconName {
    return 'edit';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.EditRecord;
  }

  public getName(): CommandName {
    return EditRecordCommand.COMMAND_NAME;
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.CURRENT;
  }
}

export default EditRecordCommand;
